import type { VideoModelConfig } from '../../types';

/** Vidu Q3 */
export const viduQ3: VideoModelConfig = {
  id: '01KMBWJVRZ4KB1FKZKNCXBH7AC',
  displayName: 'Vidu Q3',
  defaults: {
    resolution: '720P',
    duration: 5,
    sound: 'on',
  },
  resolutionOptions: [
    { label: '540P', value: '540P' },
    { label: '720P', value: '720P' },
    { label: '1080P', value: '1080P' },
  ],
  duration: { mode: 'range', min: 1, max: 16, step: 1, default: 5 },
  capabilities: {
    sound: true,
  },
  limits: {
    maxRefImages: 1,
  },
};
